module.exports = __webpack_public_path__ + "static/img/frackB.45cb0983.png";